import {useGetProfileQuery} from "../../../store/api/userApiSlice";
import {useGetQuestionQuery} from "../../../store/api/problemsetApiSlice";
import {useUpdateQuestionResponseMutation} from "../../../store/api/problemsetApiSlice";
import {useSubmitQuestionMutation} from "../../../store/api/problemsetApiSlice";
import {openLoginDialog} from "../../../store/actions/loginDialogSlice";
import {useAppDispatch} from "../../../store/hooks";

const useQuestionControl = (questionId: string | undefined) => {
  const dispatch = useAppDispatch();

  /** QUESTION API */
  const {data: userData} = useGetProfileQuery();
  const {data, isFetching: isFetching} = useGetQuestionQuery(
    {questionId: questionId!},
    {skip: !questionId},
  );
  const [updateQuestionResponse] = useUpdateQuestionResponseMutation();
  const [submitQuestion] = useSubmitQuestionMutation();

  /** OTHER ACTIONS */
  const isQuestionSubmitted = !!data?.postSubmit;
  const isValidUserResponse =
    !!data?.userAnswer && data.userAnswer.trim() !== "";

  const onSubmitQuestion = () => {
    if (!questionId) return false;
    // If user is not logged in, open login dialog
    if (!userData) {
      dispatch(openLoginDialog());
      return false;
    }
    // User answer validation
    if (!isValidUserResponse) return false;

    submitQuestion({
      questionId: questionId,
      answer: data?.userAnswer ?? "",
    });
    return true;
  };

  const onUpdateQuestionResponse = (answer: string) => {
    if (!questionId) return;
    updateQuestionResponse({
      questionId: questionId,
      answer,
    });
  };

  return {
    questionData: data,
    isQuestionFetching: isFetching,
    isQuestionSubmitted,
    isValidUserResponse,
    handleSubmitQuestion: onSubmitQuestion,
    handleQuestionResponseonUpdate: onUpdateQuestionResponse,
  };
};

export default useQuestionControl;
